<template>
  <div class="'text-top">
    <v-card :loading="isLoading" outlined>
      <v-card-title>Razorpay payment status</v-card-title>
      <v-card-subtitle>This status is directly fetched from razorpay</v-card-subtitle>
      <v-divider />
      <v-card-text v-if="paymentDetails">
        <v-simple-table>
          <tbody>
            <tr>
              <td>
                <b>Payment status</b>
              </td>
              <td>
                <div v-if="paymentDetails && paymentDetails.data.status === 'created'">
                  <v-chip>{{ paymentDetails.data.status }}</v-chip>
                  Customer has initiated payment but razorpay has not processed the payment.
                </div>
                <div v-if="paymentDetails && paymentDetails.data.status === 'captured'">
                  <v-chip color="green" text-color="white">{{ paymentDetails.data.status }}</v-chip>
                  Customer payment is verified as completed by razorpay and will be settled in vanglaini's bank account as per settlement schedule (usually T+5 working days).
                </div>
                <div v-if="paymentDetails && paymentDetails.data.status === 'authorized'">
                  <v-chip color="orange" text-color="white">{{ paymentDetails.data.status }}</v-chip>
                  The amount has been successfully authorized by customer's bank.
                </div>
                <div v-if="paymentDetails && paymentDetails.data.status === 'failed'">
                  <v-chip color="red" text-color="white">{{ paymentDetails.data.status }}</v-chip>
                  An unsuccessful payment attempt by customer
                </div>
                <div v-if="paymentDetails && paymentDetails.data.status === 'refunded'">
                  <v-chip color="blue" text-color="white">{{ paymentDetails.data.status }}</v-chip>
                  Payment has been reversed  to the customer's account.
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <b>Amount</b>
              </td>
              <td>
                ₹{{ (paymentDetails.data.amount) / 100 }}
              </td>
            </tr>
            <tr>
              <td>
                <b>Order id</b>
              </td>
              <td>
                {{ paymentDetails.data.order_id }}
              </td>
            </tr>

          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>

  </div>
</template>
<script>
import superadminApi from '@/api/superAdminApi'
export default {

  props: {
    subscriptionId: {
      type: Number,
      default: null,
      required: true
    },
    paymentId: {
      type: String,
      default: null,
      required: false
    }
  },
  data () {
    return {
      isLoading: false,
      paymentDetails: null
    }
  },
  computed: {

  },
  mounted () {
    this.fetchPayment()
  },
  methods: {
    async fetchPayment () {
      this.isLoading = true
      try {
        this.paymentDetails = await superadminApi.fetchPaymentDetail({ payment_id: this.paymentId, subscription_id: this.subscriptionId })
        console.log('response from server ', this.paymentDetails)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
